import type { Monaco } from "../_monaco";

/**
 * Prevents line breaks by removing any new lines from the content.
 *
 * Returns a cleanup function to remove event listeners and actions when no longer needed.
 */
export function enforceSingleLine(monaco: typeof Monaco, editor: Monaco.editor.IStandaloneCodeEditor): VoidFunction {
	let singleLinePosition = editor.getPosition();

	// Track the cursor position to restore it after removing new lines
	const disposableOnPositionChange = editor.onDidChangeCursorPosition(() => {
		const position = editor.getPosition();

		if (position?.lineNumber === 1) {
			singleLinePosition = position;
		}
	});

	const disposableOnValueChange = editor.onDidChangeModelContent(() => {
		const text = editor.getValue();
		// Replace all line breaks with empty string
		const singleLineText = text.replace(/\n+/gu, "");

		if (singleLineText !== text) {
			// Store the cursor position to restore it after removing new lines
			const positionBeforeValueUpdate = singleLinePosition;

			editor.setValue(singleLineText);

			if (positionBeforeValueUpdate) {
				editor.setPosition(positionBeforeValueUpdate);
			}
		}
	});

	return () => {
		disposableOnPositionChange.dispose();
		disposableOnValueChange.dispose();
	};
}
